<template>
    <div class="scc-prize-highlight">
        <div class="scc-prize-highlight__title-container">
            <h2 class="scc-prize-highlight__title">{{ title }}</h2>
        </div>
        <div class="scc-prize-highlight__wrapper wrapper" :style="`background-image: url(${imageUrl})`">
            <div class="scc-prize-highlight__body">
                <h2 class="scc-prize-highlight__prize-title">{{ prizeTitle }}</h2>
                <p class="scc-prize-highlight__prize-description">
                    {{ prizeDescription }}
                </p>
                <router-link to="/aanmelden" class="scc-prize-highlight__cta-button">{{ buttonText }}</router-link>
            </div>
        </div>
        <div class="scc-prize-highlight__body scc-prize-highlight__body--mobile">
            <h2 class="scc-prize-highlight__prize-title">{{ prizeTitle }}</h2>
            <p class="scc-prize-highlight__prize-description">
                {{ prizeDescription }}
            </p>
            <router-link to="/aanmelden" class="scc-prize-highlight__cta-button">{{ buttonText }}</router-link>
        </div>
    </div>
</template>

<script>
import './prize-highlight.scss';

export default {
    name: 'PrizeHighlight',
    __editor: {
        fields: {
            imageUrl: {
                widget: 'media',
            },
        },
    },
    props: {
        imageUrl: {
            type: String,
            default() {
                return null;
            },
        },
        title: {
            type: String,
            default() {
                return 'Prijzenpakket';
            },
        },
        prizeTitle: {
            type: String,
            default() {
                return 'Titel';
            },
        },
        prizeDescription: {
            type: String,
            default() {
                return 'Beschrijving';
            },
        },
        buttonText: {
            type: String,
            default() {
                return 'Doe mee!';
            },
        },
    },
};
</script>
